exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".doc-api-page[data-v-bf402b64]{width:1170px;padding:0 0 30px;margin:0 auto}.page-title[data-v-bf402b64]{width:100%;height:28px;line-height:28px;font-size:18px;color:#212121;text-align:center;margin:24px 0}.content-body[data-v-bf402b64]{position:relative;min-height:500px;margin-top:25px;box-shadow:0 2px 8px 0 rgba(0,0,0,.1)}.list-box[data-v-bf402b64]{position:absolute;top:0;left:0;width:237px;height:100%;padding-top:20px;background:#f4f5f6;box-sizing:border-box;overflow-y:auto}.el-menu[data-v-bf402b64]{color:#212121;border-right:0;background-color:#f4f5f6}.doc-content-box[data-v-bf402b64]{width:100%;padding:22px 25px 25px 270px;box-sizing:border-box}.updated_at_p[data-v-bf402b64]{padding:22px 25px 25px 270px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bf402b64","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/doc/generic-doc.vue
// module id = 807
// module chunks = 0